import { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import '../pages.css';

export default function Account() {
  const { user, changePassword } = useAuth();

  const [curPw, setCurPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const currentUsername = user && user.email
    ? user.email.split('@')[0]
    : '';

  const onChangePassword = async (e) => {
    e.preventDefault();
    setMsg(''); setError(''); setBusy(true);
    try {
      await changePassword(curPw, newPw);
      setMsg('密码已更新');
      setCurPw(''); setNewPw('');
    } catch (err) {
      setError(err.message || '修改失败');
    } finally { setBusy(false); }
  };

  return (
    <div className="page page-center">
      <div className="card form-card">
        <h1>我的账户</h1>
        <p className="muted">用户名：{currentUsername}（不可修改）</p>

        <form onSubmit={onChangePassword}>
          <h2>修改密码</h2>
          <label>当前密码</label>
          <input type="password" value={curPw} onChange={(e) => setCurPw(e.target.value)} autoComplete="current-password" required />
          <label>新密码</label>
          <input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} autoComplete="new-password" required />
          <button type="submit" disabled={busy}>保存密码</button>
        </form>

        {msg && <p className="success">{msg}</p>}
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
}
